import { roleBranchLabels } from '../constants/branch-labels';
import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const roleDefinition: FilterDefinition<TreeFilter> = {
  id: FilterId.ROLE,
  name: 'Role',
  selectionListIds: ['role_k7', 'role_k150', 'role_k1500', 'role_k15000'],
  selections: [],
  branches: roleBranchLabels,
  type: FilterType.TREE,
  isVisible: true,
};

export const roleHandler: FilterHandler<TreeFilter> = {
  isActive(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: TreeFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<TreeFilter>) {
    return definition.selectionListIds;
  },
};
